import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { GooglePlay, Apple } from "react-bootstrap-icons";

const GetApp = () => {
  return (
    <Container>
      <Row className="bg-primary px-md-5 px-2 py-md-5 py-3 mt-4 rounded-4 mx-2">
        <Col md={8}>
          <h1 className="text-white">Download the app</h1>
          <p className="mt-3 fs-4 text-white">
            Book manicure and pedicure appointments on the go with our
            revolutionary app.
          </p>
          <div class="d-grid gap-2 d-md-block">
            <a
              className="btn btn-outline-light btn-lg me-2 mt-2"
              //href="https://apps.apple.com/us/app/cabbily/id1624355642"
              target="_blank"
              rel="noreferrer"
            >
              <div className="d-flex flex-row align-items-center justify-content-center">
                <Apple size={22} color="#ffffff" className="me-2" />
                Download iOS App
              </div>
            </a>
            <a
              className="btn btn-outline-light btn-lg me-2 mt-2"
              //href="https://play.google.com/store/apps/details?id=com.cabbily.cabbily"
              target="_blank"
              rel="noreferrer"
            >
              <div className="d-flex flex-row align-items-center justify-content-center">
                <GooglePlay size={22} color="#ffffff" className="me-2" />
                Download Android App
              </div>
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default GetApp;
